import productService from '../../../services/product-service'
import FormatService from '../../../services/format-service'
import {mapState} from 'vuex'

export default {
    name: 'CartItem',
    props: {
        item: {}
    },
    methods: {
        deleteFromCart(id) {
            this.$store.dispatch('cart/deleteProduct', id);
        },
        updateItemQuantity(item) {
            this.$store.dispatch('cart/setProductQuantity', {product: item.product, quantity: productService.getCorrectQuantity(item.product, event.target.valueAsNumber)});
        },
        getPrice(item) {
            return productService.getCorrectPrice(item)
        },
        getTotalPrice(item) {
            return productService.getCorrectPrice(item) * item.quantity
        },
        setImageNotFound(event) {
            event.target.src = "/img/no-image-available.png"
        }
    },
    computed: {
        ...mapState({
            user: state => state.account.user
        }),
    },
    filters: {
        euro(value) {
            return FormatService.euro(value)
        }
    }
}